import React, { useState, useRef, useEffect } from "react";
import TabTitle from "../components/TabTitle"; 
import PreRegistoAluno from "../components/PreRegistoAluno";
import ListaAlunos from "../components/ListaAlunos/ListaAlunos";
import AlunoForm from "../components/AlunoForm";
import UsuarioForm from "../components/UsuarioForm";
import CadastroProfessor from "./CadastroProfessor";
import ListaProfessores from "./ListaProfessores";
import Pagamentos from "../components/Pagamentos/Pagamentos";
import Mensalidades from "../components/Mensalidades/Mensalidades.js";
import Turmas from "../components/Turmas/Turmas";
import Definicoes from "../components/Definicoes/Definicoes";
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom'; 
import { useNotification } from '../hooks/useNotification';
import { 
  FaHome,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaWallet, 
  FaCalendarAlt,
  FaUsers,
  FaChartBar,
  FaSearch,
  FaSignOutAlt, 
  FaCog,
} from "react-icons/fa";
import "./Dashboard.css";

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState("Home");
  const [isDropdownAlunosOpen, setIsDropdownAlunosOpen] = useState(false);
  const [isDropdownProfessoresOpen, setIsDropdownProfessoresOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); 
  const { logout } = useAuth();
  const { notifyLogout } = useNotification();
  const navigate = useNavigate();

  // Refs para detectar cliques fora dos dropdowns
  const dropdownAlunosRef = useRef(null);
  const dropdownProfessoresRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Fecha dropdown de alunos se clicar fora
      if (dropdownAlunosRef.current && !dropdownAlunosRef.current.contains(event.target)) {
        setIsDropdownAlunosOpen(false);
      }
      // Fecha dropdown de professores se clicar fora
      if (dropdownProfessoresRef.current && !dropdownProfessoresRef.current.contains(event.target)) {
        setIsDropdownProfessoresOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Fecha dropdowns quando mudar de aba
  useEffect(() => {
    setIsDropdownAlunosOpen(false);
    setIsDropdownProfessoresOpen(false);
  }, [activeTab]);

  const renderContent = () => {
    switch (activeTab) {
      case "Home":
        return (
          <div className="dashboard-content">
            <h2>Bem-vindo(a) ACADE - Gestor Escolar</h2>
            <div className="cards">
              <div className="card animated">
                <FaChartBar size={40} color="#4CAF50" />
                <h3>Relatórios</h3>
                <p>Resumo de desempenho e dados gerais.</p>
              </div>
              <div className="card animated">
                <FaUserGraduate size={40} color="#2196F3" />
                <h3>Alunos</h3>
                <p>Gerencie e visualize informações dos alunos.</p>
              </div>
              <div className="card animated">
                <FaWallet size={40} color="#FF9800" />
                <h3>Finanças</h3>
                <p>Acompanhe pagamentos e transações financeiras.</p>
              </div>
            </div>
          </div>
        );

      case "Cadastrar Aluno":
        return (
          <div className="dashboard-content">
            <h2>Cadastrar Aluno</h2>
            <AlunoForm />
          </div>
        );

      case "Pré-registos":
        return (
          <div className="dashboard-content">
            <h2>Pré-registos</h2>
            <PreRegistoAluno />
          </div>
        );  

      case "Lista de Alunos":
        return (
          <div className="dashboard-content">
            <h2>Lista de Alunos</h2>
            <ListaAlunos />
          </div>
        );

      case "Turmas":
        return (
          <div className="dashboard-content">
            <Turmas />
          </div>
        );

      case "Cadastrar Professor":
        return (
          <div className="dashboard-content">
            <h2>Cadastrar Professor(a)</h2>
            <CadastroProfessor />
          </div>
        );

      case "Lista de Professores":
        return (
          <div className="dashboard-content">
            <h2>ACADE-Professores(as)</h2>
            <ListaProfessores />
          </div>
        );

      case "Usuários do Sistema":
        return (
          <div className="dashboard-content">
            <h2>Usuários do ACADE</h2>
            <UsuarioForm />
          </div>
        );

      case "Finanças":
        return (
          <div className="dashboard-content">
            <Pagamentos />
          </div>
        );

      case "Mensalidades":
        return (
          <div className="dashboard-content">
            <Mensalidades />
          </div>
        );

      case "Definicoes":
        return (
          <div className="dashboard-content">
            <Definicoes />
          </div>
        );

      default:
        return <p>Conteúdo em desenvolvimento.</p>;
    }
  };

  const handleLogout = () => {
    const confirmLogout = window.confirm("Tem certeza de que deseja terminar a sessão?");
    if (confirmLogout) {
      logout(); 
      notifyLogout("Sessão Terminada!");
      navigate("/"); 
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    console.log("Pesquisando por:", searchQuery);
  };

  const toggleAlunosDropdown = () => {
    setIsDropdownAlunosOpen(!isDropdownAlunosOpen);
    setIsDropdownProfessoresOpen(false); // Fecha o outro dropdown
  };

  const toggleProfessoresDropdown = () => {
    setIsDropdownProfessoresOpen(!isDropdownProfessoresOpen);
    setIsDropdownAlunosOpen(false); // Fecha o outro dropdown
  };

  return (
    <div className="dashboard">
      <TabTitle activeTab={activeTab} /> 

      <div className="sidebar">
        <div className="logo"></div>
        <nav>
          <button className={activeTab === "Home" ? "active" : ""} onClick={() => setActiveTab("Home")}>
            <FaHome /> Início
          </button>

          {/* Dropdown Alunos */}
          <div className={`dropdown ${isDropdownAlunosOpen ? "open" : ""}`} ref={dropdownAlunosRef}>
            <button 
              className={["Cadastrar Aluno", "Pré-registos", "Lista de Alunos"].includes(activeTab) ? "active" : ""}
              onClick={toggleAlunosDropdown}
            >
              <FaUserGraduate /> Alunos
            </button>
            {isDropdownAlunosOpen && (
              <div className="dropdown-menu">
                <button onClick={() => setActiveTab("Cadastrar Aluno")}>Cadastrar Aluno</button>
                <button onClick={() => setActiveTab("Pré-registos")}>Pré-registos</button>
                <button onClick={() => setActiveTab("Lista de Alunos")}>Lista de Alunos</button>
              </div>
            )}
          </div>

          {/* Dropdown Professores */}
          <div className={`dropdown ${isDropdownProfessoresOpen ? "open" : ""}`} ref={dropdownProfessoresRef}>
            <button 
              className={["Cadastrar Professor", "Lista de Professores"].includes(activeTab) ? "active" : ""}
              onClick={toggleProfessoresDropdown}
            >
              <FaChalkboardTeacher /> Professores
            </button>
            {isDropdownProfessoresOpen && (
              <div className="dropdown-menu">
                <button onClick={() => setActiveTab("Cadastrar Professor")}>Cadastrar Professor</button>
                <button onClick={() => setActiveTab("Lista de Professores")}>Lista de Professores</button>
              </div>
            )}
          </div>

          {/* Botão Turmas */}
          <button className={activeTab === "Turmas" ? "active" : ""} onClick={() => setActiveTab("Turmas")}>
            <FaChalkboardTeacher /> Turmas
          </button>

          {/* Pagamentos */}
          <button className={activeTab === "Finanças" ? "active" : ""} onClick={() => setActiveTab("Finanças")}>
            <FaWallet /> Pagamentos
          </button>

          {/* Mensalidades */}
          <button className={activeTab === "Mensalidades" ? "active" : ""} onClick={() => setActiveTab("Mensalidades")}>
            <FaCalendarAlt /> Mensalidades
          </button>

          {/* Usuários do Sistema */}
          <button className={activeTab === "Usuários do Sistema" ? "active" : ""} onClick={() => setActiveTab("Usuários do Sistema")}>
            <FaUsers /> Usuários do Sistema
          </button>

          {/* Definições */}
          <button className={activeTab === "Definicoes" ? "active" : ""} onClick={() => setActiveTab("Definicoes")}>
            <FaCog /> Definições
          </button>

          <button onClick={handleLogout} className="logout-btn">
            <FaSignOutAlt /> Terminar Sessão
          </button>
        </nav>
      </div>

      <div className="main">
        <header>
          <div className="header-content">
            <div className="search-bar">
              <FaSearch size={20} /> Pesquisar
              <form onSubmit={handleSearchSubmit}>
                <input
                  type="text"
                  placeholder="Escreva aqui a sua pesquisa..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </form>
            </div>
            <div className="admin-info">
              <span>Usuario</span>
            </div>
          </div>
        </header>
        <main>{renderContent()}</main>
      </div>
    </div>
  );
};

export default Dashboard;